import React, { useState, useRef, useEffect, useCallback } from 'react';
import './CalendarPage.css';
import { SideMenuBar } from '../../SideMenu';
import { NewHeader } from '../../NewHeader';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import { API_URL } from '../../Config';
import { useAuth } from '../../AuthContext';

const Dashboard = () => {
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const { user } = useAuth();
  const username = user.user;
  const calendarRef = useRef(null);


  const fetchEventsFromBackend = useCallback(async () => {
    try {
      let endpoint = API_URL + `/tasks/?assignee=${username.username}`;

      if (username.role === 'Admin' || username.role === 'HR') {
        endpoint = API_URL + '/tasks/all';
      }
      const response = await fetch(endpoint);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();

      // Map the fetched data to the format expected by FullCalendar
      return data.map(task => ({
        title: task.taskDetails,
        start: task.deadline,
        assignee: task.assignee,
      }));
    } catch (error) {
      console.error('Error fetching events:', error);
      return [];
    }
  },[username]);

  useEffect(() => {
    // Fetch events from the backend API
    fetchEventsFromBackend().then(data => setEvents(data));
  }, [username, fetchEventsFromBackend]);

  const handleEventClick = (arg) => {
    setSelectedEvent(arg.event);
  };
  const closePopup = () => {
    setSelectedEvent(null);
  };

  return (
    <div>
      <SideMenuBar></SideMenuBar>

      <div className="content">
        <NewHeader></NewHeader>

        <div className="row2">
          <h3 className="calendar_CalendarPage">Calendar</h3>
        </div>

        <div className="row3_CalendarPage">
          <FullCalendar
            ref={calendarRef}
            plugins={[dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin]}
            initialView="dayGridMonth"
            headerToolbar={{
              left: 'prev,next today',
              center: 'title',
              right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek',
            }}
            events={events}
            editable={true}
            selectable={true}
            selectMirror={true}
            dayMaxEvents={(info) => info.dayEvents.length > 1 ? true : 1} 
            eventClick={handleEventClick}
            eventContent={(arg) => (
              <>
                <b>{arg.timeText}</b>
                <i>Task: {arg.event.title}</i>
                <p>Assignee: {arg.event.extendedProps.assignee}</p>
              </>
            )}
          />
        </div>
      </div>
      {selectedEvent && (
        <div className="popup">
          <div className="overlay" onClick={closePopup}></div>
          <div className="popup-content">
            <h2>Event Details</h2>
            <p>Title: {selectedEvent.title}</p>
            <p>Assignee: {selectedEvent.extendedProps.assignee}</p>
            <button onClick={closePopup}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
